import get from 'lodash/get';

import fetchQuery from 'rebook/apps/utils/fetchQuery';
import { BOOK_PLAYER_SET_DATA } from 'rebook/apps/base/constants';


export const setBookData = (book) => {
  return (dispatch) => {
    if (!book) {
      return null;
    }
    const bookId = get(book, 'id', '');
    const isAudio = get(book, 'type', '') === 'audio';
    const availableForUser = get(book, 'available_for_user', false);
    const rentBookPaymentLink = `${get(book, 'absolute_url', '')}payments`;
    if (isAudio) {
      dispatch(setData({
        bookId,
        availableForUser,
        rentBookPaymentLink,
      }));
    }
    else {
      return null;
    }
  };
};

export const updateBookData = () => {
  return async(dispatch, getState) => {
    const { player, ssr } = getState();
    const { bookId } = player;
    const url = `/api/books/${bookId}`;
    return await fetchQuery(url, { apiVersion: 4, headers: ssr.headers })
      .then(
        ({ data }) => {
          const { id, available_for_user: availableForUser } = data;
          const rentBookPaymentLink = `${get(data, 'absolute_url', '')}payments`;
          dispatch(setData({
            bookId: id,
            availableForUser,
            rentBookPaymentLink,
          }));
        }
      )
      .catch(
        ({ data, resp, error }) => {
          if (resp.status === 404) {
            dispatch(Error404Actions.show());
          }
          else {
            Raven.captureMessage('failed to load book data to server error', {
              level: 'error',
              extra: {
                status: resp.status,
                response: data,
                error,
              },
            });
            throw new Error('failed to load book data to server error');
          }
        }
      );
  };
};

export const showPlayer = () => {
  return (dispatch) => {
    dispatch(setData({
      showPlayer: true,
    }));
  };
};

export const hidePlayer = () => {
  return (dispatch) => {
    dispatch(setData({
      showPlayer: false,
    }));
  };
};

export const setData = (payload) => {
  return {
    type: BOOK_PLAYER_SET_DATA,
    payload,
  };
};
